import _ from "lodash";

export const pluralizeWord = function (items = [], word) {
  return items.length > 1 ? _.cloneDeep(word) + "s" : _.cloneDeep(word);
};
